var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs-spinner",class:{ 'has-delay': _vm.delay }},[_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }